import React from "react";
import { Message, Grid } from "semantic-ui-react";
import { Link } from "react-router-dom";

export const Thankyou = () => {
  return (
    <Grid padded centered>
      <Grid.Row>
        <Grid.Column computer={8} tablet={8} mobile={16}>
          <Message positive>
            <Message.Header>Thank you for registering</Message.Header>
            <p>
              A verification email has been sent to you. Once you verify your
              email address, you will be able to <Link to="/">login</Link>, but
              you won't be able to use BannerMatic until your account has been
              approved.
            </p>
          </Message>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export const Waiting = () => {
  return (
    <Grid padded centered>
      <Grid.Row>
        <Grid.Column computer={8} tablet={8} mobile={16}>
          <Message positive>
            <Message.Header>Waiting approval</Message.Header>
            <p>
              Your account still needs to be approved. Once it's approved,
              you'll have access to the full power of BannerMatic. Please check
              with your account manager for approval progress.
            </p>
          </Message>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};
